module.exports = __webpack_public_path__ + "img/DE00764.3914f350.png";